<template>
  <div>
    <div class="column is-12 is-margin-top-40">
      <p class="has-text-centered">
        <img src="/static/img/spinner.svg" alt="Processing NPS Feedback..." />
      </p>
    </div>
  </div>
</template>
<script>
  /* eslint-disable indent,no-new,no-undef */
  import axios from 'axios'

  export default {
    metaInfo: {
      title: 'Business Portal | Hellopeter - Processing NPS Feedback...'
    },
    mounted () {
      this.$gtm.trackEvent({
        event: 'pageLoad',
        virtualPageUrl: this.$router.currentRoute.path,
        virtualPageTitle: 'Processing NPS Feedback'
      })
    },
    name: 'NpsReviewRedirectFromEmail',
    props: {
      npsSelection: {
        type: String
      },
      reviewPermalink: {
        type: String
      }
    },
    created () {
      const data = {
        nps_selection: this.npsSelection,
        review_slug: this.reviewPermalink
      }
      axios.post(`/nps/review-feedback`, data)
        .then(() => {
          this.$router.push('/nps/thank-you')
        })
        .catch(() => {
          this.$router.push('/nps/thank-you')
        })
    }
  }
</script>


// WEBPACK FOOTER //
// src/pages/nps/NPSReviewRedirectFromEmail.vue